export class Result
{
    constructor(
        public success:boolean,
        public errorMessage:string
    ){
        if(success && errorMessage)
            throw new Error('errorMessage defined for success');
        if(!success && !errorMessage)
            throw new Error('no errorMessage defined for error');
    }

    static fail(errorMessage:string){
        return new Result(false, errorMessage);
    }

    static succeed(){
        return new Result(true, '');
    }

    static chain(results:Result[])
    {
        for(const r of results){
            if(!r.success)
                return r;
        }
        return Result.succeed();
    }
}